<template>
  <a-card :bordered="false">
    <SmallSquare class="m-b-15" content="1、可创建会员营销、客户关怀、消息通知等短信模板，用于会员营销、商品宣传、卡券获取及商户后台各种活动通知等；
2、短信内容需合法，不能发送房产、发票、移民等国家法律法规严格禁止的内容；
3、超链接地址请写在短信内容中，便于核实，部分安卓系统存在超链接识别问题，需在超链接前后添加空格。" />
    <app-warp title='短信'>
      <template #app-title>
        <div class="app-sms-title">
          <LeftOutlined />
          <div>
            <a-avatar :size="30">
              <template #icon>
                <UserOutlined />
              </template>
            </a-avatar>
          </div>
        </div>
      </template>
      <template #app-content>
        <div class="app-sms-warp">
          <div class="app-sms-info">
            <p>短信/彩信</p>
            <p>今天 {{nowTime}}</p>
          </div>
          <div class="app-sms-content" v-html="form.content"></div>
        </div>
      </template>
      <template #app-sider>
        <a-form :model="form" ref='ruleForm' :label-col="labelCol" :wrapper-col="wrapperCol" style="margin-left:70px">
          <a-divider />
          <a-form-item label="模版名称" name='name' :rules="[{ required: true, message: '请设置模版名称' }]">
            <a-input v-model:value="form.name" placeholder="请输入模板名称" />
          </a-form-item>
          <a-form-item label="模版内容" name='content' :rules="[{ required: true, message: '请设置模版内容' }]">
            <div class="ant-form-explain m-t-5">
              您可选择营销、会员关怀类等短信模版进行参考修改
              <a-button @click="templateVisible=true" type="link" class='m-r-20'> 短信模板 </a-button>
            </div>
            <a-textarea v-model:value="form.content" placeholder="请输入模板内容..." :rows="4" />
            <div style="font-size:12px;color:#f04635">{{form.content.length}}
              个字，预计分成{{Math.ceil(form.content.length/70)}}条短信收费(70个字计一条，超出70字后67字计一条)</div>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="onSubmit" class='m-r-10'> 提交模板申请 </a-button>
            <a-button @click="$router.go(-1)" class='m-r-20'> 返回 </a-button>
          </a-form-item>
        </a-form>
      </template>
    </app-warp>
  </a-card>
  <a-modal  :keyboard="false" title="短信模板" centered v-model:visible="templateVisible" :footer="null" :width="1200" destroyOnClose>
    <smsTemplate @success="chooseTemplate" />
  </a-modal>
</template>
<script>
  import {
    reactive,
    toRefs,
    ref,
    inject,onMounted
  } from "vue";
  import { createSmsTemplate } from "@/api/message";
  import { message, Modal } from "ant-design-vue";
  import { UserOutlined, LeftOutlined } from "@ant-design/icons-vue";
  import { iscode } from "@/utils/app";
  import smsTemplate from "./components/smsTemplate";
  export default {
    components: { UserOutlined, LeftOutlined, smsTemplate },
    setup(props) {
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span: 18 },
        form: {
          name: "",
          content: "",
        },
        templateVisible: false,
        nowTime:'0:00'
      });
      
      const momentTime=inject('momentTime')
      const setOldMap = ref();
      const handleChoose = (data) => {
        state.form.background_map = `url(${data}) `;
        state.form.background = data;
      };
      const $router = inject("$router");
      const $route = inject("$route");
      // 保存
      const ruleForm = ref();
      const onSubmit = () => {
        ruleForm.value.validate().then(async (e) => {
          let result = await createSmsTemplate({...state.form}).then((res) => res.data).catch((error) => error);
          if (iscode(result, true)) {
            $router.go(-1);
          }
        }).catch((error) => { });
      };
      const content = ref();
      // 选择模板
      const chooseTemplate = (data) => {
        state.templateVisible = false;
        state.form.content = data.content;
      };
      onMounted(() => {
        state.nowTime = momentTime().locale('zh-cn').format('HH:mm');
      });
      return {
        ...toRefs(state),
        handleChoose,
        ruleForm,
        onSubmit,
        content,
        chooseTemplate,
      };
    },
  };
</script>
<style lang="less" scoped>
  @import url("@/style/app-warp/app-warp.less");

  .ant-checkbox-wrapper {
    width: 500px;
  }

  .normal_map {
    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin-right: 10px;
        margin-bottom: 10px;

        // background: url(https://zx-oss.hebeigaoda.com/ydd_resource/20201113/e6933b585fea645a0180f2f24ed95c50.png)  ;
        label {
          width: 57px;
          height: 57px;
          display: block;
          border: 1px solid transparent;
        }

        input:checked~label {
          border: 1px solid #05486A;
        }
      }
    }
  }
</style>